var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInviteSentIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 123,
    viewBox: "0 0 123 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8857_64589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4144 109.534C75.0877 116.681 102.505 100.852 109.652 74.1782C116.799 47.5049 100.97 20.088 74.2963 12.941C47.623 5.79386 20.2061 21.623 13.059 48.2963C5.91196 74.9696 21.7411 102.386 48.4144 109.534Z",
    fill: "#3876BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6367 53.0498L40.6304 56.4651V50.2012L36.6367 53.0498Z",
    fill: "#A4D7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 55.1777V84.8148L53.3522 69.9956L36 55.1777Z",
    fill: "#A4D7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0667 36.3664L56.666 38.7878H65.7984L62.3512 36.3604C61.6658 35.8776 60.7496 35.8801 60.0667 36.3665V36.3664Z",
    fill: "#A4D7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7645 71.3345L61.9974 76.2606C61.8146 76.4222 61.5717 76.5035 61.3383 76.5035C61.105 76.5035 60.8721 76.4222 60.6797 76.2601L54.9126 71.334L37.7324 86.0006H84.9453L67.7645 71.3345Z",
    fill: "#A4D7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0469 56.4653L86.0406 53.06L82.0469 50.2422V56.4653Z",
    fill: "#A4D7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6783 84.8148V55.1777L69.3262 69.9956L86.6783 84.8148Z",
    fill: "#A4D7FA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 43,
    width: 32,
    height: 18,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6582 42.7928V58.1989L61.3383 74.1521L80.0183 58.1989V42.7928C80.0183 41.7013 79.1334 40.8164 78.042 40.8164H44.6346C43.5426 40.8164 42.6582 41.7013 42.6582 42.7928ZM67.8046 59.7596H54.8816C54.3139 59.7596 53.868 59.3035 53.868 58.7459C53.868 58.1782 54.3139 57.7322 54.8816 57.7322H67.8046C68.3622 57.7322 68.8183 58.1782 68.8183 58.7459C68.8183 59.3035 68.3622 59.7596 67.8046 59.7596ZM49.4892 45.1034H73.1861C73.7538 45.1034 74.1998 45.5595 74.1998 46.1171C74.1998 46.6747 73.7538 47.1308 73.1861 47.1308L49.4892 47.1302C48.9315 47.1302 48.4755 46.6742 48.4755 46.1166C48.4755 45.5589 48.9315 45.1034 49.4892 45.1034ZM49.4892 51.4179H73.1861C73.7538 51.4179 74.1998 51.874 74.1998 52.4316C74.1998 52.9892 73.7538 53.4453 73.1861 53.4453L49.4892 53.4448C48.9315 53.4448 48.4755 52.9887 48.4755 52.4311C48.4755 51.874 48.9315 51.4179 49.4892 51.4179Z",
    fill: "#FF7A7A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 81,
    r: 9,
    fill: "#CBF4C9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 83.0012,
    cy: 80.9993,
    r: 6.86842,
    fill: "#27AE60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4574 78.1232C86.4556 78.2627 86.3999 78.3644 86.3284 78.4612C85.6731 79.3475 85.0181 80.234 84.3636 81.1209C83.7493 81.9527 83.1352 82.7846 82.5212 83.6166C82.3626 83.8315 82.1087 83.9022 81.9028 83.7859C81.8594 83.7609 81.8197 83.7301 81.7848 83.6944C81.1323 83.0337 80.4805 82.3723 79.8291 81.7104C79.6924 81.5717 79.6457 81.4079 79.7161 81.2285C79.7847 81.0539 79.9182 80.9427 80.1154 80.9261C80.2247 80.9168 80.3337 80.9473 80.4218 81.0118C80.9236 81.3658 81.4255 81.7198 81.9275 82.0738C82.0274 82.1441 82.1244 82.1249 82.2119 82.0195C82.3512 81.8518 82.4888 81.6829 82.6271 81.5144C83.615 80.3106 84.603 79.1068 85.591 77.9032C85.7805 77.6724 86.026 77.6197 86.2473 77.7632C86.3088 77.8024 86.36 77.8555 86.3966 77.9181C86.4331 77.9807 86.4539 78.051 86.4574 78.1232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6087 41.5991C33.362 41.5397 33.3917 40.1445 33.3917 40.1445C33.362 41.6733 32.1152 41.5991 32.1152 41.5991C32.1152 41.5991 33.3917 41.7178 33.3917 43.0091C33.3917 43.0091 33.5401 41.7178 34.6087 41.5991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0862 39.2542C31.2995 39.2097 31.3144 38.334 31.3144 38.334C31.2995 39.2987 30.498 39.2542 30.498 39.2542C30.498 39.2542 31.3144 39.3284 31.3144 40.1447C31.3144 40.1447 31.4183 39.3284 32.0862 39.2542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5807 42.0884C28.7904 41.9399 28.8646 38.8379 28.8646 38.8379C28.7904 42.2368 26 42.0884 26 42.0884C26 42.0884 28.8646 42.3704 28.8646 45.2498C28.8646 45.2498 29.2356 42.3555 31.5807 42.0884Z",
    fill: "#A4D7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.387 89.3031C88.5622 89.7237 88.1267 91.0495 88.1267 91.0495C88.6011 89.5959 89.772 90.0306 89.772 90.0306C89.772 90.0306 88.5857 89.5446 88.9625 88.3095C88.9625 88.3095 88.4438 89.5013 87.387 89.3031Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.1166 92.2815C89.856 92.5536 89.5864 93.3868 89.5864 93.3868C89.882 92.4684 90.6357 92.7448 90.6357 92.7448C90.6357 92.7448 89.8765 92.4357 90.1147 91.6549C90.1147 91.6549 89.7771 92.4054 89.1166 92.2815Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.4248 89.7179C93.0505 90.6739 92.0745 93.6194 92.0745 93.6194C93.1371 90.39 95.7628 91.346 95.7628 91.346C95.7628 91.346 93.1051 90.2406 93.9451 87.4864C93.9451 87.4864 92.7458 90.1465 90.4248 89.7179Z",
    fill: "#F2B85C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9483 60.0245C97.5739 60.9806 96.5979 63.926 96.5979 63.926C97.6605 60.6966 100.286 61.6527 100.286 61.6527C100.286 61.6527 97.6285 60.5472 98.4686 57.7931C98.4686 57.7931 97.2693 60.4531 94.9483 60.0245Z",
    fill: "#FF9D9C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0449 27.3807L59.6089 26.1191",
    stroke: "url(#paint0_linear_8857_64589)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2324 26L57.4847 27.4397",
    stroke: "url(#paint1_linear_8857_64589)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.1406 26.7871L55.9866 27.7667",
    stroke: "url(#paint2_linear_8857_64589)",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8642 95.7738L58.9566 96.8159",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1934 97.6211L61.372 96.1704",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4258 97.4805L62.9024 96.2967",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8857_64589",
    x1: 59.3269,
    y1: 26.1191,
    x2: 59.3269,
    y2: 27.3807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3876BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66B0DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8857_64589",
    x1: 57.3586,
    y1: 26,
    x2: 57.3586,
    y2: 27.4397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3876BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66B0DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8857_64589",
    x1: 55.5636,
    y1: 26.7871,
    x2: 55.5636,
    y2: 27.7667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3876BB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66B0DD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8857_64589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(26) rotate(15)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteSentIcon);
export default __webpack_public_path__ + "static/media/InviteSentIcon.b13c58b5dbdc1ce6618e2a0d0ed140f9.svg";
export { ForwardRef as ReactComponent };